/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Card/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import CardBrand from './CardBrand/index'
import Expiry from './Expiry/index'
import HolderName from './HolderName/index'
import Last4 from './Last4/index'
import LocationName from './LocationName/index'
import PlatformFee from './PlatformFee/index'
import React from 'react'
import Surcharge from './Surcharge/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Card({
  children,
  viewPath = "/DesignSystem/PaymentProvider/PaymentProviderMethod/Content/ReusableMethods/Method/Details/Card"
  
}) {
let dtSpaceXxxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxxs'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtColorsNeutral300 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.300'
        })
  return (<React.Fragment
>
<CardBrand
  viewPath={`${viewPath}/CardBrand`}
/>
<div
  data-testid="Card.Vertical"
  data-view-path={viewPath}
 style={{'--g-1-9dqY': typeof dtSpaceXxxs === 'number' ? `${dtSpaceXxxs}px` : dtSpaceXxxs,'--ml-2-9dqY': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="Card.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<Last4
  viewPath={`${viewPath}/Last4`}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsNeutral300}
 text="•"
/>
<Expiry
  viewPath={`${viewPath}/Expiry`}
/>
</div>
<div
  data-testid="Card.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<HolderName
  viewPath={`${viewPath}/HolderName`}
/>
<LocationName
  viewPath={`${viewPath}/LocationName`}
/>
</div>
<PlatformFee
  viewPath={`${viewPath}/PlatformFee`}
/>
<Surcharge
  viewPath={`${viewPath}/Surcharge`}
/>
</div>
{children}
</React.Fragment>)
}